import React from "react";
import Tabs from "components/Tabs";
import { WHITE_TAB_STYLES } from "components/Tabs";
import { SETTINGS_TABS } from "utils/constants/settings";
import startCase from "lodash/startCase";
import SectionHeader from "components/SectionHeader";
import { useTabPathPrefix } from "utils/hooks";
import SettingsMetadatasContainer from "./SettingsMetadatasContainer";

const SECTION_COMPONENT_MAP = {
  [SETTINGS_TABS.METADATA]: SettingsMetadatasContainer
};

const PageSettingsSection = ({ sections = [SETTINGS_TABS.METADATA] }) => {
  const pathPrefix = useTabPathPrefix();

  const tabProps = {
    minWidth: false,
    equalWidth: false,
    pathPrefix,
    customStyles: WHITE_TAB_STYLES,
    customClasses: {
      tabs: {
        list:
          "list ma0 pa0 nowrap center overflow-x-auto absolute top-0 left-0 right-0 ph3"
      }
    },
    tabs: sections.reduce((memo, section) => {
      const TabComponent = SECTION_COMPONENT_MAP[section];

      if (TabComponent) {
        memo.push({
          name: startCase(section),
          id: section,
          node: (
            <div className="ph3 pb3 pt4">
              <TabComponent />
            </div>
          )
        });
      }
      return memo;
    }, [])
  };

  return (
    <div className="w-100 bg-white overflow-y-scroll-ns h-100">
      <SectionHeader
        header="Settings"
        subheader="Adjust your page metadata with these settings."
      />
      <div className="pt3 mt2">
        <Tabs {...tabProps} />
      </div>
    </div>
  );
};

export default PageSettingsSection;
